@if (packageType$ | async; as packageType) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded()) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: packageType }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: packageType }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <elder-basic-pane-layout class="flex">
      <!-- General -->
      <elder-pane class="flex">
        <elder-pane-header>
          <elder-pane-title>{{ 'context.details' | translate }}</elder-pane-title>
          <elder-pane-actions>
            <button mat-icon-button [disabled]="!mainFrm.form.valid" (click)="onSave($event)">
              <mat-icon>save</mat-icon>
            </button>
            <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode$ | async">
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="onDelete($event)" [disabled]="!canDelete">
                <mat-icon>delete</mat-icon>
                <span>{{ 'actions.delete' | translate }}</span>
              </button>
            </mat-menu>
          </elder-pane-actions>
        </elder-pane-header>
        <elder-pane-content>
          <form #mainFrm="ngForm" class="flex">
            <mat-tab-group
              class="full"
              animationDuration="0"
              mat-stretch-tabs="false"
              elderTabGroupRouting="packageTypeDetail"
            >
              <mat-tab label="{{ 'context.general' | translate }}" elderTab="general">
                <app-package-type-general class="flex"> </app-package-type-general>
              </mat-tab>
              <mat-tab label="{{ 'context.presets' | translate }}" class="flex" elderTab="presets">
                <app-package-type-presets class="flex"> </app-package-type-presets>
              </mat-tab>
              <mat-tab label="{{ 'labeling.title' | translate }}" class="flex" elderTab="labeling">
                <app-package-type-labeling class="flex"> </app-package-type-labeling>
              </mat-tab>
            </mat-tab-group>
          </form>
        </elder-pane-content>
      </elder-pane>
    </elder-basic-pane-layout>
  </div>
}

<ng-template #header let-type>
  @if (creationMode$ | async) {
    <span>
      {{ 'packages.types.new' | translate }}
    </span>
  } @else {
    <elder-header [header]="'packages.types.type' | translate" [subheader]="'ID: ' + type.id">
    </elder-header>
  }
</ng-template>
